import type { useChangeHistoryDataQuery$variables } from './hooks/__generated__/useChangeHistoryDataQuery.graphql.ts';

export const CHANGE_HISTORY_PAGE_SIZE = 100;

export const buildChangeHistoryDataQueryVariables = (
	contentId: string,
): useChangeHistoryDataQuery$variables => ({
	contentId,
	after: null,
	first: CHANGE_HISTORY_PAGE_SIZE,
});
